import React, { useState } from 'react';
import './App.css';

function App() {
  const [city, setCity] = useState('');
  const [weatherData, setWeatherData] = useState(null);

  const fetchWeather = async (e) => {
    e.preventDefault();
    // Check if the city input is empty and alert the user
    if (!city.trim()) {
      alert('Please enter at least one letter to submit the city name.');
      return;
    }

    try {
      const response = await fetch(`https://cityweather-django-react-be.vercel.app/weather?city=${city}`);
      if (!response.ok) {
        throw new Error('Failed to fetch weather data');
      }
      const data = await response.json();
      setWeatherData(data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const convertToFahrenheit = (celsius) => {
    return celsius ? ((celsius * 9) / 5 + 32).toFixed(2) : '';
  };

  const formattedCity = () => {
    return city
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <div id="app">
      <h1>Weather Checker</h1>
      <form onSubmit={fetchWeather}>
        <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Enter a city name" />
        <button type="submit">Get Weather</button>
      </form>

      {weatherData && (
        <div>
          <h2>Weather in {formattedCity()}:</h2>
          <p>{weatherData.weather[0]?.description}</p>
          <p>Temperature: {weatherData.main?.temp}°C / {convertToFahrenheit(weatherData.main?.temp)}°F</p>
          <p>Humidity: {weatherData.main?.humidity}%</p>
          <p>Wind Speed: {weatherData.wind?.speed} km/h</p>
        </div>
      )}
    </div>
  );
}

export default App;
